import script from "./introPage.vue?vue&type=script&setup=true&lang=js"
export * from "./introPage.vue?vue&type=script&setup=true&lang=js"

import "./introPage.vue?vue&type=style&index=0&id=a45cab56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a45cab56"]])

export default __exports__